// API call for fetching the list of soft tags
import authorizedAPIInstance from '@/api/authorizedAPI';
import type {
  CreateSoftTagParams,
  CreateSoftTagDTO,
  EditSoftTagParams,
  ValidateCodeParams,
  ValidateCodeResponse,
} from '../utils/types';
import { mapCreateSoftTagDTOToResponse } from '../utils/helpers';

export const createSoftTagApi = async (
  params?: CreateSoftTagParams
): Promise<any> => {
  const { data } = await authorizedAPIInstance.post<CreateSoftTagDTO>(
    '/soft-tag',
    params
  );
  // Map DTO array to frontend response format
  const responseData: any = mapCreateSoftTagDTOToResponse(data);
  return responseData;
};

export const editSoftTagApi = async (
  params?: EditSoftTagParams
): Promise<any> => {
  const newParams = { ...params };
  delete newParams?.id;
  const { data } = await authorizedAPIInstance.put<CreateSoftTagDTO>(
    `/soft-tag/${params?.id}`,
    newParams
  );
  return data;
};

export const validateCodeApi = async (
  params: ValidateCodeParams
): Promise<ValidateCodeResponse> => {
  const { data } = await authorizedAPIInstance.post<ValidateCodeResponse>(
    '/validate',
    params
  );
  return data;
};
